// extracted by css-extract-rspack-plugin
export default {"ImageCard":"Lc_Fs","UpsellCta":"wGPvo"};